import { z } from 'zod';

/* The maximum number of lines a Ledger Entry can have, by default. */
export const MAX_ENTRY_LINES = 30;

/**
 * The maximum number of lines a Ledger Entry can have if an internal API
 * chooses to bypass the above limit.
 */
export const MAX_INTERNAL_ENTRY_LINES_LIMIT = 55;

/**
 * The maximum number of lines a batch of Ledger Entries can have between them.
 * A batch commits as one DynamoDB transaction, whose item budget every line
 * spends against.
 */
export const MAX_BATCH_ENTRY_LINES = 30;

/** The kind of Ledger Entry a stored entry is. */
export const LedgerEntryFlavor = {
  /** "traditional" entries */
  journal: 'journal',
  /** A Payment Type's accounting entry, posted only by Fragment's payments flow. */
  payment: 'payment',
} as const;
export const LedgerEntryFlavorSchema = z.nativeEnum(LedgerEntryFlavor);
export type LedgerEntryFlavor = z.infer<typeof LedgerEntryFlavorSchema>;
